import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_eed54686";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_eed54686" };
/** script content **/
require("./index.ts?ctorType=page&index=0&isFirst&isPage&lang=ts&mpx&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fexample%2Fpages%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_eed54686"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'theme-container': getComponent(require("../components/theme-container/index.mpx?isComponent&outputPath=components%2Findex714cd67f%2Findex")), 'cubeButton': getComponent(require("../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")), 'cube-icon': getComponent(require("../../packages/mpx-cube-ui/src/components/icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex")), 'cube-picker-modal': getComponent(require("../../packages/mpx-cube-ui/src/components/picker-modal/index.mpx?isComponent&outputPath=components%2Findexa989b916%2Findex")), 'mpx-scroll-view': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
